<template>
    <div class="tenant-management">
        <div class="tenant-management-wrap">
            <router-view></router-view>
        </div>
    </div>
</template>
<script>
export default {
    name: 'tenantManagement',
    data () {
        return {

        }
    }
}
</script>
<style lang="scss" scoped>
    .tenant-management{
        position: relative;
        .tenant-management-wrap{
            padding: 40px;
        }
    }
    @media screen and (max-width: 1280px){
        .tenant-management{
            .tenant-management-wrap{
                padding: 30px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/tenantManagementPages/TenantManagement.vue